goog.provide('el8.appchart.visitNote.labsProblemsDialog');

goog.require('el8.service.tz');
goog.require('el8.uiwidget.Feed');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.template.appchart.visitNote.labsProblemsDialog');
goog.require('el8.ptdata.base');
goog.require('el8.appchart.showItemDetail');
goog.require('el8.util.feed');

el8.appchart.visitNote.labsProblemsDialog = (function() {

    var PAGE_SIZE = 5;
    var feed = null;
    var lastVisitDate = null;
    var currNoteId = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Import Lab Values and Problems into Note',
        autoHeight: 600,
        width: 500,
        modal: false,
        contentFn: el8.template.appchart.visitNote.labsProblemsDialog.content
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'reference', 'Reference', function() {
            var selected = [];
            $('input:checkbox:checked', that.getContentElt()).each(function(index, elt) {
                var fid = $(elt).attr('_fid');
                var id = el8.util.feed.fromFeedItemId(fid)['id'];
                selected.push(id);
            });
            if (selected.length) {
                el8.appchart.mgr.notes.autoImportLabsProblems({
                    type: 'reports',
                    reportIds: selected
                });
                that.hide();
            } else {
                el8.uiwidget.alert('No labs selected.');
            }
        }, true
    );
    buttonSet.addButton(
        'cancel', 'Cancel', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);

    var renderer = function(item) {
        if (item.is('Report')) {
            return function(item, feedId) {
                return el8.template.appchart.visitNote.labsProblemsDialog.labReport({
                    feedId: feedId,
                    feedItemId: item.getFeedItemId(),
                    documentDate: el8.service.tz.soyStr(item.getDocumentDate()),
                    isSignedOff: item.isSignedOff(),
                    description: item.getDescription(),
                    abnormalResultsStr: item.hasGrids() ? item.getDisplayAbnormalResults() : null,
                    cardSummary: item.getCardSummary()
                });
            };
        } else {
            return function() { return ''; };
        }
    };

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        feed = new el8.uiwidget.Feed({
            container: that.getContentElt().find('.feed-container'),
            scrollContainer: that.getContentElt(),
            name: 'labs-problems',
            urlIndex: el8Globals['PATIENT_PATH']+'structured-reports-index/',
            rendererFn: renderer,
            fetchFn: el8.ptdata.fetch,
            pageSize: PAGE_SIZE,
            skeletonFn: el8.template.appchart.visitNote.labsProblemsDialog.feed,
            moreTrigger: '#labs-problems-more-btn',
            addlRenderItemFn: function(rendered, item) {
                if (lastVisitDate && (item.getDocumentDate() > lastVisitDate)) {
                    rendered.find('input:checkbox').prop('checked', true).trigger('change');
                }
            },
            noScroll: true
        });

        var $contentElt = $(that.getContentElt()[0]);

        $contentElt.on('change', 'input:checkbox', function() {
            if ($(this).is(':checked')) {
                _selectItem($(this).closest('li'));
            } else {
                _unselectItem($(this).closest('li'));
            }
            return false;
        });
        $contentElt.on('click', '.feed-item', function(e) {
            if ($(e.target).is('input:checkbox')) { return; }
            var $checkbox = $('input:checkbox', $(this));
            if (!$checkbox.is(':checked')) {
                $checkbox.prop('checked', true).trigger('change');
            } else {
                $checkbox.prop('checked', false).trigger('change');
            }
            return false;
        });
        $contentElt.on('click', '.view-trigger', function(e) {
            var fid = $(this).attr('_fid');
            var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
            el8.appchart.dialog.reports.show({
                item: item,
                forcePosition: 'right'
            });
            return false;
        });
    };

    function _selectItem($elt) {
        $elt.addClass('el8ItemSelected');
    }
    function _unselectItem($elt) {
        $elt.removeClass('el8ItemSelected');
    }

    var super_show = that.show;
    that.show = function(_currNoteId) {
        currNoteId = _currNoteId;
        lastVisitDate = el8.appchart.mainFeeds.chart.getLastVisitDate();
        super_show.call(that);
        _loadContent();
    };

    var super_hide = that.hide;
    that.hide = function() {
        if (feed) { feed.resetRender(); }
        super_hide.call(that);
    };

    function _loadContent() {
        /* Do full refresh of the feed on every show */
        feed.refresh({
            async: true,
            successCb: function() {
                var noLabs = feed.isEmpty();
                var noIcd9s = !el8.ptdata.ptProblems.hasIcd9Codes();
                if (noLabs || noIcd9s) {
                    $('.feature-available-container', that.getContentElt()).hide();
                    $('.feature-unavailable-container', that.getContentElt()).html(
                        el8.template.appchart.visitNote.labsProblemsDialog.unavailable({
                            noLabs: noLabs,
                            noIcd9s: noIcd9s
                        })
                    );
                    buttonSet.disableButton('reference');
                } else {
                    $('.feature-available-container', that.getContentElt()).show();
                    $('.feature-unavailable-container', that.getContentElt()).empty();
                    buttonSet.enableButton('reference');
                }
            }
        });
    }

    return that;

})();
